import { Breadcrumb, Button, Col, Form, Input, Row, Typography } from "antd";
import { Content } from "antd/lib/layout/layout";

import { t } from "i18next";
import React, { useRef, useState } from "react";
import { Link } from "react-router-dom";
import ButtonField from "../../common/htmlComponents/ButtonField";
import { authUserData } from "../../utils/Helper";
import { CloseOutlined } from "@ant-design/icons";
import { patchRequest, postRequest } from "../../axios";
import { ErrorNotificationMsg, SuccessNotificationMsg } from "../../utils/Notifications";

const { Text } = Typography;

export const ReturnPortalScan = () => {
  const [loading, setLoading] = useState(false);
  const formRef = useRef("");
  const [form] = Form.useForm();
  const [state, setState] = useState({
    hawb: null,
    status: "RD- Return to depo",
    warehouse_coordinates: {
      latitude: null,
      longitude: null,
    },
  });
  const handleInputChange = (e) => {
    console.log("Value", e.target.value);
    setState((prevState) => ({
      ...prevState,
      hawb: e.target.value,
    }));
  };
  const DepoManagerId = authUserData()?.depo_manager_id
    ? authUserData()?.depo_manager_id
    : "";
    const getCurrentLocation = () => {
      return new Promise((resolve) => {
        if (!navigator.geolocation) {
          resolve(null);
          return;
        }
    
        navigator.geolocation.getCurrentPosition(
          (position) => {
            resolve({
              // latitude: position.coords.latitude,
              // longitude: position.coords.longitude,
              latitude: Number(position.coords.latitude.toFixed(6)),
              longitude: Number(position.coords.longitude.toFixed(6)),
            });
          },
          (error) => {
            resolve(null); // Permission denied OR error
          },
          {
            enableHighAccuracy: true,
            timeout: 5000, // Wait max 5 sec
            maximumAge: 0,
          }
        );
      });
    };
  const handleButtonClick = async () => {
    const location = await getCurrentLocation();
    const payload = {
      hawb: state.hawb,
      warehouse_latitude: location?.latitude,
      warehouse_longitude: location?.longitude,
      // warehouse_latitude: authUserData()?.warehouse_latitude,
      // warehouse_longitude: authUserData()?.warehouse_longitude,
    };
    try {
      setLoading(true);
      const apiResponse = await postRequest(
        "return-parcel/return-parcel-by-depo-manager/",
        payload
      );
      
      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("Package Returned To Depo"));
        formRef.resetFields();
      } else {
        ErrorNotificationMsg(apiResponse.data.message)

        console.log(apiResponse.data.message, "abcdfgf");
      }
    } catch (error) {
      setLoading(false);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleResetInput = () => {
    setState((prevState) => ({
      ...prevState,
      hawb: null,
    }));
    form.resetFields();
  };
  return (
    <>
      {/* Top Bar Section */}
      <div className="ListingTopBar">
        <div className="pagenamewrap">
          <div className="pagename">
            <h3>{t("pl_returnPortal")}</h3>

            {/* Breadcrumb */}
            <Breadcrumb className="Breadcrumb-Sec">
              <Breadcrumb.Item>
                <Link to="/dashboard">{t("home")}</Link>
              </Breadcrumb.Item>
              <Breadcrumb.Item>{t("Return Portal")}</Breadcrumb.Item>
            </Breadcrumb>
          </div>
        </div>
      </div>

      {/* Main Section */}
      <section className="grid-sec">
        <div className="Package-body">
          <div className="filterrow packagefilter">
            <Content className="content-section">
              {/* <Text type="secondary">Returned Parcel Scanning</Text> */}

              {/* Input, Button, and Select on One Line */}
              <Form
                ref={formRef}
                form={form}
                onFinish={handleButtonClick}
                layout="vertical" // Layout for labels on top
              >
                <Row
                  gutter={16}
                  className="input-group-row"
                  align="middle"
                  justify="space-between"
                >
                  {/* Input Section */}

                  <Col xs={24} sm={8}>
                    <div
                      className="flex-row"
                      style={{
                        display: "flex",
                        gap: "10px",
                        textAlign: "center",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <Form.Item
                        style={{ width: "100%" }}
                        label="Returned Parcel Scanning"
                        name="hawb"
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Parcel Tracking Number",
                          },
                        ]}
                      >
                        <Input
                          className="ant-input parcel-input"
                          style={{ width: "100%" }}
                          placeholder="Enter Parcel Tracking Number"
                          value={state?.hawb}
                          onChange={handleInputChange}
                        />
                      </Form.Item>

                      <div style={{ alignItems: "center", margin: "10px" }}>
                        <Button
                          style={{
                            background: "#F95C19",
                            border: "none",
                            alignItems: "center",
                          }}
                          type="primary"
                          shape="circle"
                          icon={<CloseOutlined />}
                          onClick={handleResetInput}
                        />
                        {/* </Tooltip> */}
                      </div>
                      <ButtonField
                        className="ant-btn ant-btn-primary save-gradient-btn SaveGradiantBtn"
                        type="primary"
                        htmlType="Submit"
                        label="Scan Parcel"
                      />
                    </div>
                  </Col>
                </Row>
              </Form>
            </Content>
          </div>
        </div>
      </section>
    </>
  );
};
export default ReturnPortalScan;
